import { render, staticRenderFns } from "./CodeConfig.vue?vue&type=template&id=5bee055f&scoped=true"
import script from "./CodeConfig.vue?vue&type=script&lang=js"
export * from "./CodeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee055f",
  null
  
)

export default component.exports